import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StandbyCancelResultEffect } from './standby-cancel-result.effect';
import { standbyCancelResultReducer } from './standby-cancel-result.reducer';
import { STANDBY_CANCEL_RESULT_STORE_NAME, StandbyCancelResultState } from './standby-cancel-result.state';

/** Token of the StandbyCancelResult reducer */
export const STANDBY_CANCEL_RESULT_REDUCER_TOKEN = new InjectionToken<ActionReducer<StandbyCancelResultState, Action>>(
  'Feature StandbyCancelResult Reducer'
);

/** Provide default reducer for StandbyCancelResult store */
export function getDefaultStandbyCancelResultReducer() {
  return standbyCancelResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(STANDBY_CANCEL_RESULT_STORE_NAME, STANDBY_CANCEL_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([StandbyCancelResultEffect]),
  ],
  providers: [{ provide: STANDBY_CANCEL_RESULT_REDUCER_TOKEN, useFactory: getDefaultStandbyCancelResultReducer }],
})
export class StandbyCancelResultStoreModule {
  public static forRoot<T extends StandbyCancelResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<StandbyCancelResultStoreModule> {
    return {
      ngModule: StandbyCancelResultStoreModule,
      providers: [{ provide: STANDBY_CANCEL_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
